window.arPageDetailFormatter = function(value, row) {
    let html = '';
    if (row.introduction) {
        html += '<span class="fw-bold">'+__('Introduction')+'</span>';
        html += '<p>'+row.introduction+'</p>';
    }
    return html;
};
